export const ModalHorizontalDivider = () => (
  <div className='my-6 border-t border-neutral-200' />
);
